﻿'use strict';

import './anexos.css';

var centralApp = angular.module('app.components');

centralApp.component('anexos', {
    bindings: {
        arquivos: '=',
        dimensao: '=?',
        excluido: '&?'
    },
    controllerAs: '$ctrl',
    controller: anexosCtrl,
    template: require('./anexos-template.html')
});

centralApp.component('arquivo', {
    require: {
        anexos: '^?anexos'
    },
    bindings: {
        arquivo: '<',
        excluir: '&'
    },
    controllerAs: '$ctrl',
    controller: arquivoAnexoCtrl,
    template: [
        '<span class="label label-primary pull-left anexo" title="{{ ::$ctrl.arquivo.name }}">',
            '{{ ::$ctrl.arquivo.name | htmlLimpo: 30 }} ',
            '<a href="" ng-click="$ctrl.excluirArquivo()" style="color: #fff">x</a>',
        '</span>'
    ].join('')
});

anexosCtrl.$inject = ['$scope', '$timeout', 'Event'];
function anexosCtrl($scope, $timeout, Event)
{
    var $ctrl = this;

    $ctrl.arquivo = null;

    $ctrl.colarArquivo = colarArquivo;
    $ctrl.adicionarTransferido = adicionarTransferido;
    $ctrl.adicionarAnexo = adicionarAnexo;
    $ctrl.ehImagem = ehImagem;

    // Começamos verificando se o navegador suporta o 
    // objeto Clipboard. Se não, precisamos criar um 
    // elemento contenteditable que captura todos os 
    // dados colados
    if (false /*!window.Clipboard */) {
        var pasteCatcher = document.createElement("div");
            
        // Firefox permite que imagens sejam coladas em 
        // elementos contenteditable
        pasteCatcher.setAttribute("contenteditable", "");
            
        // Podemos esconder o elemento e anexá-lo ao body
        pasteCatcher.style.opacity = 0;
        document.body.appendChild(pasteCatcher);
        
        // Nós certifique-se que está sempre no foco
        pasteCatcher.focus();
        document.addEventListener("click", function() { 
            pasteCatcher.focus(); 
        });

        // Adicinoa o outvinte de eventos colar
        window.addEventListener("paste", $ctrl.colarArquivo);
    } 


    /**
     * Executado após o componetes estar pronto
     * para renderização.
     */
    $ctrl.$onInit = function(){
        $ctrl.dimensao = $ctrl.dimensao || 0;
        $ctrl.arquivos = $ctrl.arquivos || [];
    }

    /**
     * Calcula a dimensao totao dos arquivos
     * adicionado como anexo.
     */
    $scope.calcularDimensaoArquivo = function () {
        $ctrl.dimensao = _.sumBy($ctrl.arquivos, 'size');
    };

    // Calcula dimensão total dos arquivos
    $scope.calcularDimensaoArquivo();

    /**
     * Exclui arquivo da lista de anexos
     * 
     * @param object arquivo
     */
    $ctrl.excluirArquivo = function (arquivo) {
        
        var index = $ctrl.arquivos.indexOf(arquivo);
        $ctrl.arquivos.splice(index, 1);

        if ($ctrl.excluido) {
            $ctrl.excluido({
                arquivo: arquivo
            });
        }

    };

    // Vamos observar mudanças no arquivo para 
    // adiciona-los a lista
    $scope.$watch('$ctrl.arquivo', function (arquivos) {

        if (arquivos) {
            if (arquivos.length > 1) {
                _.each(arquivos, function (arquivo) {
                    $ctrl.adicionarAnexo(arquivo);
                })
            } else {
                $ctrl.adicionarAnexo(_.first(arquivos));
            }
        }

        $scope.calcularDimensaoArquivo();
    });

    /**
     * Adiciona o arquivo a lista de anexos
     * 
     * @param File arquivo
     */
    function adicionarAnexo(arquivo) {
        arquivo.ehImagem = $ctrl.ehImagem(arquivo.type);

        $ctrl.arquivos.push(arquivo);
    }

    /**
     * Permite a adição de arquivos no campo anexo.
     * Mas para está função funcionar é necessário o 
     * uso do evento paste.
     * 
     * @param object event
     * @param handler callback
     */
    function colarArquivo(event, callback) {

        var items = (
            _.get(event, 'clipboardData', null) || 
            _.get(event, 'originalEvent.clipboardData', {})
        ).items || [];

        var files = [].slice.call(items)

        files.forEach(function (file) {
            if($ctrl.ehImagem(file.type)) {
                $ctrl.adicionarTransferido(
                    file.getAsFile(),  callback
                );
            }
        })

    }

    function ehImagem (tipo) {
        return /png|jpg|jpeg|gif/g.test(tipo);
    }

    /**
     * Adiciona na lista de anexos o arquivo 
     * obtido da área de transferência.
     * 
     * @param Blob arquivo
     * @param handler callback
     */
    function adicionarTransferido(arquivo, callback) {

        if (arquivo) {

            // O arquivo obtido da área de transf~encia
            // não tem nome, então vamos criar um alternativo.
            var nomeArquivo = [
                'imagem-capturada-',
                moment().format('DDMMYYYYHHmmss'),
                _.last(arquivo.type.split('/'))
            ].join('.');

            // Criamos o arquivo
            var arquivoTransferido = new File([arquivo], nomeArquivo, { type: arquivo.type, lastModified: moment() });

            // Adicionamos o arquivo da área de transferência
            // na lista de arquivos em anexo.
            $ctrl.adicionarAnexo(arquivoTransferido);

            $scope.calcularDimensaoArquivo();

            // Executamos uma função de callback
            (callback || _.noop)(arquivoTransferido);
        }

    }

    /**
     * Este ouvinte nos possibilita ter um recurso adicional que
     * permir o usuário enviar arquivos para o campo de anexo
     * de qualquer lugar da página com o envento paste do angular.
     * 
     * @param object event
     * @param object originalEvent
     */
    Event.on('anexo.colar-arquivo', function (event, originalEvent, handle) {
        
        if (originalEvent) {

            $ctrl.colarArquivo(originalEvent, function (arquivo) {

                $timeout(function () {
                    ( handle || _.noop )(arquivo);
                    
                    $scope.$apply();
                }, 100);

            });
        }

    });
}

arquivoAnexoCtrl.$inject = ['$scope'];

/**
 * Exclui o arquivo da lista
 */
function arquivoAnexoCtrl($scope)
{
    var $ctrl = this;

    $ctrl.excluirArquivo = function () {
        $ctrl.excluir($ctrl.arquivo);
    }
}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/anexos/index.js
// module id = 305
// module chunks = 1